import { render, staticRenderFns } from "./LessonTemplatePrinterExample.vue?vue&type=template&id=09aa15da"
import script from "./LessonTemplatePrinterExample.vue?vue&type=script&lang=js"
export * from "./LessonTemplatePrinterExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports